__webpack_require__.p = "https://www.cassandras.be/cassandras/";